import { AppPermission, AppRole, PredefinedRoles } from "@/types/role";

function hasPermissions(userPermissions: AppPermission[], requiredPermissions: AppPermission[]) {
  return requiredPermissions.every((requiredPermission) => userPermissions.some(userPermission => userPermission === requiredPermission));
}

export const canWriteCampaignAndSpaces = computed(() => {
  return (userRoles: AppRole[]) => {
    if (!userRoles || userRoles.length === 0) return false;
    for (const role of userRoles) {
      let permissions: AppPermission[] = [];
      if (role.role_backward_compatibility_id !== null && role.role_backward_compatibility_id !== undefined) {
        permissions = PredefinedRoles[role.role_backward_compatibility_id]
      } else {
        permissions = role.permissions;
      }
      if (hasPermissions(permissions, [AppPermission.CAMPAIGN_WRITE])) {
        return true;
      }
    }
  }
});

export const canWriteBillings = computed(() => {
  return (userRoles: AppRole[]) => {
    if (!userRoles || userRoles.length === 0) return false;
    for (const role of userRoles) {
      let permissions: AppPermission[] = [];
      if (role.role_backward_compatibility_id !== null && role.role_backward_compatibility_id !== undefined) {
        permissions = PredefinedRoles[role.role_backward_compatibility_id]
      } else {
        permissions = role.permissions;
      }
      if (hasPermissions(permissions, [AppPermission.BILLING_WRITE])) {
        return true;
      }
    }
  }
});

export const canInviteParticipants = computed(() => {
  return (userRoles: AppRole[]) => {
    if (!userRoles || userRoles.length === 0) return false;
    for (const role of userRoles) {
      let permissions: AppPermission[] = [];
      if (role.role_backward_compatibility_id !== null && role.role_backward_compatibility_id !== undefined) {
        permissions = PredefinedRoles[role.role_backward_compatibility_id]
      } else {
        permissions = role.permissions;
      }
      if (hasPermissions(permissions, [AppPermission.INVITE_WRITE_PARTICIPANT])) {
        return true;
      }
    }
  }
});

export const canWriteMembers = computed(() => {
  return (userRoles: AppRole[]) => {
    if (!userRoles || userRoles.length === 0) return false;
    for (const role of userRoles) {
      let permissions: AppPermission[] = [];
      if (role.role_backward_compatibility_id !== null && role.role_backward_compatibility_id !== undefined) {
        permissions = PredefinedRoles[role.role_backward_compatibility_id]
      } else {
        permissions = role.permissions;
      }
      if (hasPermissions(permissions, [AppPermission.INVITE_WRITE])) {
        return true;
      }
    }
  }
});

export const canManageOrganisation = computed(() => {
  return (userRoles: AppRole[]) => {
    if (!userRoles || userRoles.length === 0) return false;
    for (const role of userRoles) {
      let permissions: AppPermission[] = [];
      if (role.role_backward_compatibility_id !== null && role.role_backward_compatibility_id !== undefined) {
        permissions = PredefinedRoles[role.role_backward_compatibility_id]
      } else {
        permissions = role.permissions;
      }
      if (hasPermissions(permissions, [AppPermission.ORGANIZATION_MANAGE])) {
        return true;
      }
    }
  }
});